import { userAPI } from '@/services-ts/axios'
import type { IPermissionExternal, IRoleGroup } from '@/types/Data'
import type { IGetRoleGroupList, ISavePermission } from '@/types/Request'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useRoleStore = defineStore('role', {
  actions: {
    async GetRoleGroupList(payload: IGetRoleGroupList): Promise<IRoleGroup[]> {
      const { status, data } = await userAPI.RoleServices.GetRoleGroupList(payload)
      return status ? data : []
    },

    async GetPermissionList(RoleGroupId: string): Promise<IPermissionExternal[]> {
      const { status, data } = await userAPI.RoleServices.GetPermissionList(RoleGroupId)
      return status ? data : []
    },

    async SetPermission(payload: ISavePermission) {
      const { status } = await userAPI.RoleServices.SetPermission(payload)
      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },
  },
})
